export enum ServerErrorsEnum {
  RESOURCE_ALREADY_HAS_SUBTASK_ASSIGNED_IN_DATE_RANGE = 'RESOURCE_ALREADY_HAS_SUBTASK_ASSIGNED_IN_DATE_RANGE',
  RESOURCE_HAS_ACTIVE_SUBTASK = 'RESOURCE_HAS_ACTIVE_SUBTASK',
  CONTAINER_NUMBER_EXISTS = 'CONTAINER_NUMBER_EXISTS',
  CONTAINER_MISSING_NUMBER = 'CONTAINER_MISSING_NUMBER',
  INVALID_TASK_TYPE = 'INVALID_TASK_TYPE',
}
